<script setup>
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';

import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  iconOnly: {
    type: Boolean,
    default: false,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);
</script>

<template>
  <button
    type="button"
    class="flex cursor-pointer items-center font-normal text-n-slate-11 transition-colors hover:text-n-slate-12"
    :class="
      iconOnly
        ? 'size-7 shrink-0 justify-center rounded-lg p-0 hover:bg-n-alpha-2 dark:hover:bg-n-alpha-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-n-blue-9'
        : `p-0 ${compact ? 'text-sm' : 'text-base'}`
    "
    :aria-label="iconOnly ? ariaLabel : undefined"
    @click="emit('click', $event)"
  >
    <HugeIcon
      :icon="ArrowLeft01Icon"
      :size="iconOnly ? 24 : 20"
      class="shrink-0 text-n-slate-11 rtl:rotate-180"
      :class="[iconOnly ? 'size-6' : '-ms-0.5']"
    />
    <span v-if="!iconOnly" class="ms-0.5">{{ label }}</span>
  </button>
</template>
